goog.provide('el8.appchart.dialog.ordermed.fulfillRefill');

goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.appchart.dialog.ordermed.fulfillRefill');
goog.require('el8.ptdata.base');
goog.require('el8.service.tz');
goog.require('el8.util.amplitude.prescriptionFormHelpers');

el8.appchart.dialog.ordermed.fulfillRefill = (function() {

    var refill = null,
        authRefills = null,
        note = null,
        noChange = false;

    var that = new el8.uiwidget.NewDialog({
        title: 'Refill Summary',
        autoHeight: true,
        width: 600,
        position: 'center'
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'approve', 'Approve', function() {
            el8.util.amplitude.completeRenewalRxResponse('Approve', refill.isMedicationControlled());
            if (el8Globals.FEATURES.MDToolboxEPCS && el8.data.currUser.isEpcsEnabled() && refill.isMedicationControlled()) {
                el8.ptdata.rxRefillRequests.submitControlledApproval(refill, authRefills, note, noChange);
            }
            else {
                el8.ptdata.rxRefillRequests.submitApproval(refill, authRefills, note, noChange);
            }
            that.hide();
        }, true
    );
    buttonSet.addButton(
        'deny', 'Deny', function() {
            el8.util.amplitude.completeRenewalRxResponse('Deny', refill.isMedicationControlled());
            el8.ptdata.rxRefillRequests.submitDenial(refill, note);
            that.hide();
        }, true
    );
    buttonSet.addButton(
        'cancel', 'Cancel', function() {
            el8.util.amplitude.completeRenewalRxResponse('Cancel', refill.isMedicationControlled());
            that.hide();
        }
    );
    that.setButtonSet(buttonSet);

    var super_show = that.show;
    that.show = function(mode, _refill, _authRefills, _note, _noChange) {
        super_show.call(that);

        refill = _refill;
        authRefills = _authRefills || null;
        note = _note || null;
        noChange = Boolean(_noChange);

        var signUserBehalfName = (el8.data.currUser.getRxDelegatingPhysicianIdsInWorkspace().length) ?
            el8.data.currUser.getFullName() : null;

        // Show the user signing this refill response if they are different from the original prescriber
        // regardless of delegate status. See SWAT-1431 for more background regarding this change.
        if (!signUserBehalfName && el8.data.currUser.id !== refill._prescriberId) {
            signUserBehalfName = el8.data.currUser.getFullName();
        }

        that.setContent(el8.template.appchart.dialog.ordermed.fulfillRefill.content({
            mode: mode,
            rxPrescriberName: refill.getPrescriberName(),
            signUserBehalfName: signUserBehalfName,
            practice : el8.data.currPractice.asSoyMap(),
            patient : el8.ptdata.currPatient.asSoyMap(),
            documentDate: el8.service.tz.soyStr(el8.service.tz.now()),
            note: note,
            authRefills: authRefills,
            refill: refill.asSoyMap(),
            isControlled: refill.isMedicationControlled(),
            originalRefillRequest: refill.getOriginalSpec()
        }));

        if (mode === 'deny') {
            buttonSet.hideButton('approve');
            buttonSet.showButton('deny');
            buttonSet.focusButton('deny'); //focus on Deny button
        } else {
            buttonSet.hideButton('deny');
            buttonSet.showButton('approve');
            buttonSet.focusButton('approve'); //focus on Approve button
        }

        that.adjustPosition();
    };

    that.showApprove = function(_refill, _authRefills, _note, _noChange) {
        that.show('approve', _refill, _authRefills, _note, _noChange);
    };
    that.showDeny = function(_refill, _note) {
        that.show('deny', _refill, null, _note, null);
    };

    var super_hide = that.hide;
    that.hide = function() {
        refill = null;
        authRefills = null;
        note = null;
        noChange = false;
        super_hide.call(that);
    };

    return that;

})();
